import { render, staticRenderFns } from "./shehuizuzhi.vue?vue&type=template&id=53f59e1d&scoped=true&"
import script from "./shehuizuzhi.vue?vue&type=script&lang=js&"
export * from "./shehuizuzhi.vue?vue&type=script&lang=js&"
import style0 from "./shehuizuzhi.vue?vue&type=style&index=0&id=53f59e1d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f59e1d",
  null
  
)

export default component.exports